export default __webpack_public_path__ + "static/media/673.785247f7.png";